/* Louise Arlette : pop-ups natifs, résumé des avis et minuteur du panier. */
if (!customElements.get('la-modal')) customElements.define('la-modal', class extends HTMLElement {
 connectedCallback(){
  this.abort?.abort();this.abort=new AbortController();const options={signal:this.abort.signal};
  this.dialog=this.querySelector('dialog');if(!this.dialog)return;
  this.addEventListener('click',e=>{if(e.target.closest('[data-la-open]')){this.dialog.showModal();document.documentElement.classList.add('la-modal-open')}if(e.target.closest('[data-la-close]'))this.dialog.close()},options);
  this.dialog.addEventListener('click',e=>{if(e.target!==this.dialog)return;const r=this.dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)this.dialog.close()},options);
  this.dialog.addEventListener('close',()=>{if(!document.querySelector('la-modal dialog[open]'))document.documentElement.classList.remove('la-modal-open')},options);
 }
 disconnectedCallback(){this.abort?.abort();if(!document.querySelector('la-modal dialog[open]'))document.documentElement.classList.remove('la-modal-open')}
});
/* Le bloc « Résumé des avis » lit la note et le nombre d'avis de la section « Avis clients universel ». */
const laSyncReviewSummary=()=>{
 const section=document.querySelector('rvu-reviews[data-count]');
 document.querySelectorAll('[data-la-review-summary]').forEach(link=>{
  const count=Number(section?.dataset.count||0),rating=Number(String(section?.dataset.rating||0).replace(',','.'));
  const stars=link.querySelector('.la-review-summary__stars'),label=link.querySelector('.la-review-summary__text');
  if(section?.id)link.setAttribute('href','#'+section.id);
  if(count&&rating){
   const full=Math.round(rating);stars.hidden=false;stars.textContent='★'.repeat(full)+'☆'.repeat(5-full);
   const tpl=link.dataset.template||'[note] / 5 · [nombre] avis';
   label.textContent=tpl.replace('[note]',rating.toFixed(1).replace('.',',')).replace('[nombre]',count.toLocaleString('fr-FR'));
  } else {stars.hidden=true;label.textContent=link.dataset.emptyLabel||'Avis clients'}
  link.hidden=!section;
 });
 document.querySelectorAll('[data-la-scroll-reviews]').forEach(a=>{if(section?.id)a.setAttribute('href','#'+section.id)});
};
if(!customElements.get('la-hold-timer'))customElements.define('la-hold-timer',class extends HTMLElement{
 /* Minuteur de réservation : repart de la durée complète à chaque ouverture du panier. */
 connectedCallback(){
  const duration=Math.max(1000,Number(this.dataset.seconds||600)*1000);
  const key='la-hold-deadline';
  const minutes=this.querySelector('[data-part="m"]');
  const seconds=this.querySelector('[data-part="s"]');
  const pad=n=>String(n).padStart(2,'0');
  const store=v=>{try{sessionStorage.setItem(key,String(v))}catch(e){}this._end=v};
  const read=()=>{let v=0;try{v=Number(sessionStorage.getItem(key)||0)}catch(e){}return v||this._end||0};
  const reset=()=>store(Date.now()+duration);
  const tick=()=>{
   let left=read()-Date.now();
   if(left<=0){reset();left=duration}
   const total=Math.ceil(left/1000);
   if(minutes)minutes.textContent=pad(Math.floor(total/60));
   if(seconds)seconds.textContent=pad(total%60);
   this.setAttribute('aria-label',`${this.dataset.label||'Réservé pendant'} ${minutes?.textContent||'10'} minutes ${seconds?.textContent||'00'} secondes`);
  };
  const dialog=this.closest('dialog');
  if(dialog){
   this._wasOpen=dialog.hasAttribute('open');
   if(!read())reset();
   this._obs=new MutationObserver(()=>{const open=dialog.hasAttribute('open');if(open&&!this._wasOpen){reset();tick()}this._wasOpen=open});
   this._obs.observe(dialog,{attributes:true,attributeFilter:['open']});
  }else{reset()}
  tick();
  this._timer=setInterval(tick,250);
 }
 disconnectedCallback(){clearInterval(this._timer);if(this._obs)this._obs.disconnect()}
});
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',laSyncReviewSummary,{once:true});else laSyncReviewSummary();
document.addEventListener('shopify:section:load',()=>setTimeout(laSyncReviewSummary,50));
document.addEventListener('shopify:section:unload',()=>setTimeout(laSyncReviewSummary,50));

/* Barre de livraison offerte : seuil en devise principale, converti avec le taux Shopify. */
if(!customElements.get('la-free-shipping'))customElements.define('la-free-shipping',class extends HTMLElement{
 connectedCallback(){
  const d=this.dataset;const rate=(d.currency!==d.baseCurrency&&window.Shopify?.currency?.rate)?Number(window.Shopify.currency.rate):1;
  const threshold=Math.round(Number(d.threshold||0)*rate),total=Number(d.total||0);
  const left=Math.max(0,threshold-total),pct=threshold>0?Math.min(100,total/threshold*100):0;
  let money;try{money=new Intl.NumberFormat(d.locale||'fr',{style:'currency',currency:d.currency}).format(left/100)}catch(e){money=(left/100).toFixed(2)}
  const text=this.querySelector('[data-fs-text]'),fill=this.querySelector('[data-fs-fill]');
  if(text){if(left>0){text.innerHTML='';const parts=(d.text||'').split('[montant]');parts.forEach((p,i)=>{text.append(p);if(i<parts.length-1){const b=document.createElement('strong');b.textContent=money;text.append(b)}})}else text.textContent=d.done||''}
  if(fill)requestAnimationFrame(()=>{fill.style.width=pct+'%'});
 }
});
